import React, { useContext, useMemo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import ProductConditions from '../product-conditions';
import { VariantGroups } from '../variant-groups';
import { ProductConditionSummary, VariantGroup } from 'src/types';
import { FiltersWrapper } from './styles';

export const ProductFilters: React.VFC<IProductFilterProps> = props => {
  const {
    categoryId,
    conditions,
    showProductVariantsInHeader = false,
    variantGroups,
  } = props;
  const { market } = useContext(AppContext);

  const hasVariantGroups =
    variantGroups &&
    variantGroups.length > 0 &&
    market.productVariantCategories?.find(c => c === categoryId);

  // ProductConditions should be visible if product has used offers.
  // ProductConditions should then continue to be visible, even if a selected variant has no conditions.
  // This is why it is wrapped in useMemo, to prevent the ProductConditions from being displayed and hidden back and forth in the UI when selecting variants.
  const showConditions = useMemo(
    () =>
      Boolean(conditions?.filter(c => c.name === 'used' && c.count > 0).length),
    []
  );

  return showConditions || hasVariantGroups ? (
    <FiltersWrapper $showProductVariantsInHeader={showProductVariantsInHeader}>
      {showConditions && <ProductConditions conditions={conditions} />}
      {hasVariantGroups && <VariantGroups variantGroups={variantGroups!} />}
    </FiltersWrapper>
  ) : null;
};

interface IProductFilterProps {
  categoryId?: string;
  conditions: ProductConditionSummary[];
  showProductVariantsInHeader?: boolean;
  variantGroups?: VariantGroup[] | null;
}
